import { ContactMetadata } from '../../../../types/contact'

export type ContactMetadataManageDialogProps = {
  isOpen: boolean
  onClose?: () => void
  onSubmit: (metadata: ContactMetadata, isCreating: boolean) => Promise<ContactMetadata>
  metadata?: ContactMetadata
  companyId?: number
  companyName?: string
  contactId: number
  contactName: string
  isSuccess: boolean
  isFetching: boolean
}
